// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS CityState INSTEAD.
import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';

/**
 * @visibleName CityState DEPRECATED
*/

var CityState = function CityState(_ref) {
  var _ref$address = _ref.address,
    address = _ref$address === void 0 ? {} : _ref$address;
  var hasCity = !isEmpty(address.city);
  var hasState = !isEmpty(address.state);
  if (hasCity && hasState) {
    return /*#__PURE__*/React.createElement("span", null, address.city, ", ", /*#__PURE__*/React.createElement("abbr", null, address.state, " "));
  }
  if (hasCity) {
    return /*#__PURE__*/React.createElement("span", null, address.city, " ");
  }
  if (hasState) {
    return /*#__PURE__*/React.createElement("span", null, address.state, " ");
  }
  return null;
};
CityState.propTypes = {
  address: PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string
  }).isRequired
};
export default CityState;